// extracted by mini-css-extract-plugin
export default {"p_content":"aa3f26d835"};